// extracted by mini-css-extract-plugin
export default {"notification":"_9kbSwor27h"};